import React, { useMemo } from 'react';
import { Select, SelectProps } from './Select';
import { useCurrencies } from '@app/api';

export const CurrencyCodeSelect = (
  props: SelectProps<false, { value: string; label: string }>,
) => {
  const { data: currencies } = useCurrencies();
  const options = useMemo(() => {
    if (!currencies) {
      return [];
    }
    return currencies.map(({ code, name }) => ({
      label: `${name} (${code})`,
      value: code,
    }));
  }, [currencies]);

  return <Select {...props} options={options} />;
};
